<template>
  <div>
    <div v-if="!twilioSyncStore.isTwilioFrameworkAvailable">
      Twilio Framework Not Available, try refreshing
    </div>
    <div v-else>
      <button @click="loggingStore.log('test', 'data')">Add Log</button>
      &nbsp;
      <button @click="loggingStore.clearLogs()">🗑 Clear</button>
      <table style="width:400px">
        <tr>
          <th>TS</th>
          <th>Key</th>
          <th>Data</th>
        </tr>
        <tr v-for="log in loggingStore.sortedLogs" :key="log.data.index">
          <th>{{$util.formatDate(log.data.value.ts)}}</th>
          <th>{{log.data.value.key}}</th>
          <th>{{log.data.value.data}}</th>
          
        </tr>
      </table>

      
      
    </div>
    
  </div>
</template>

<script>
export default {
  name:"FunctionLogging",
  inject: ['functionLoggingPage'],
  data(){
    return {
      // logs:[]
    }
  },
  computed:{
    twilioSyncStore(){
      return this.functionLoggingPage.$refs.twilioSyncStore
    },
    loggingStore(){
      return this.functionLoggingPage.$refs.loggingStore
    },
  },
}
</script>